import { open, publicKeysOf, sign } from "@gigsync/crypto";
/**
 * Keys held in memory, from secrets the shell loaded (the app from its keystore, tests from newDeviceSecrets()).
 * The secrets never leave this object except through what the shell itself persisted.
 */
export class SecretKeys {
    secrets;
    publics;
    constructor(secrets) {
        this.secrets = secrets;
        this.publics = publicKeysOf(secrets);
    }
    async publicKeys() {
        return this.publics;
    }
    async sign(bytes) {
        return sign(bytes, this.secrets.signing);
    }
    async open(sealed, device) {
        return open(sealed, device, this.secrets.encryption);
    }
}
//# sourceMappingURL=keys.js.map